export default __webpack_public_path__ + "static/media/swiftstrikes2.1ec7b5e2.png";